export default "__VITE_ASSET__BhjM4ZYh__"